import { withErrorHandler } from '@utils/errorHandler';

export const InputField = (properties: {
  label?: string;
  id?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  autoComplete?: string;
  value?: string | number | string[];
  maxLength?: number;
  minLength?: number;
  name?: string;
  onChange?: React.ChangeEventHandler;
  disabled?: boolean;
  style?: React.CSSProperties;
}) => (
  <div
    className={`form-field${properties.disabled ? ' disabled' : ''} ${
      properties.value || properties.placeholder ? ' isNotEmpty' : ''
    }`}
  >
    <label htmlFor={properties.id}>
      <div className='input-label-wrapper'>{properties.label}</div>
    </label>

    <input
      id={properties.id}
      type={properties.type}
      placeholder={properties.placeholder}
      required={properties.required}
      autoComplete={properties.autoComplete}
      value={properties.value}
      maxLength={properties.maxLength}
      minLength={properties.minLength}
      onChange={properties.onChange && withErrorHandler(properties.onChange)}
      style={properties.style}
    />
  </div>
);
